// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__8dhdz","errors":"Errors_errors__12SEs"};